<div class="h-full flex flex-col md:flex-row">
  <div class="bg-black h-72 w-full border-b-8 border-jcb md:max-w-[360px] md:min-w-[360px] lg:max-w-[460px] lg:min-w-[460px] xl:max-w-1/3 xl:min-w-1/3 md:h-full md:border-b-0 md:border-r-8 bg-no-repeat bg-center bg-cover bg-[url('/assets/images/no-access-hero.jpg')]"></div>
  <div class="h-full overflow-y-auto flex-grow">
    <router-outlet></router-outlet>
  </div>
</div>


